export default {
  kw: 'kW',
};



// WEBPACK FOOTER //
// ./js/lang/en/units.js